'use client';

import MuiIcon from '@mui/material/Icon';
import { TBIcon } from './type';

type Props = {
  icon: TBIcon;
  size?: number | string;
  className?: string;
};

const TbIcon = ({ icon, size = 24, className }: Props) => {
  if (icon.kind === 'custom') {
    return (
      <img
        src={icon.image.url}
        alt={icon.image.altText}
        width={size}
        height={size}
        className={className}
        style={{ objectFit: 'contain' }}
      />
    );
  }

  return (
    <MuiIcon className={className} sx={{ fontSize: size }}>
      {icon.name}
    </MuiIcon>
  );
};

export default TbIcon;
